function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from '../select';
import './homeMap.scss';
import { PlacesProvider } from '../../dataProvider/places';
import SvgMap from '../maps/index';
import CustomMap from './customMap';
import Card from '../card/index';
export const HomeMap = ({
  firstSelectList,
  firstLevelSelectedItem,
  onFirstSelectChange,
  secondSelectList,
  onSecondSelectChange,
  mapData,
  onMapSelectionChange
}) => {
  const _useState = useState(firstLevelSelectedItem),
        _useState2 = _slicedToArray(_useState, 2),
        firstLevelSelected = _useState2[0],
        changeFirstLevelSelected = _useState2[1];

  const firstLevelChange = e => {
    changeFirstLevelSelected(e);
  };

  return React.createElement("div", {
    className: "HomeMap"
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "selectsContainer"
  }, React.createElement(PlacesProvider, {
    type: "PROVINCE"
  }, data => {
    return React.createElement(Select, {
      placeholder: "Seleccione provincia",
      items: data,
      selected: firstLevelSelected,
      valueKey: "ineId",
      onChangeSelection: firstLevelChange
    });
  }), React.createElement(PlacesProvider, {
    type: "TOWN",
    parent: true
  }, data => {
    return React.createElement(Select, {
      items: data || [],
      placeholder: "Seleccione municipio",
      valueKey: "ineId"
    });
  })), React.createElement(PlacesProvider, {
    type: "PROVINCE"
  }, data => {
    return React.createElement(CustomMap, {
      maps: data
    });
  }), React.createElement("div", null, React.createElement(Card, {
    title: "ESCRUTADO:",
    titleValue: "75%",
    subtitle: "Actualizado a las: 22:35"
  }))), React.createElement("div", {
    className: "grid-row"
  }));
};
HomeMap.propTypes = {
  firstLevelSelectedItem: PropTypes.string,
  firstSelectList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    parent: PropTypes.string
  })).isRequired,
  onFirstSelectChange: PropTypes.func.isRequired,
  secondSelectList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    parent: PropTypes.string
  })),
  onSecondSelectChange: PropTypes.func.isRequired,
  mapData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    svg: PropTypes.string,
    winner: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    parent: PropTypes.string
  })).isRequired,
  onMapSelectionChange: PropTypes.func.isRequired
};
HomeMap.defaultProps = {
  secondSelectList: [],
  firstLevelSelectedItem: ''
};
export default HomeMap;